export default __webpack_public_path__ + "static/media/california.7372b35e.png";